module.exports = __webpack_public_path__ + "media/loan_payments_calculator/savings_btn_hover-86133068.png";